module.exports = __webpack_public_path__ + "static/img/waplogo.b1d84287.png";